import { module } from 'angular';
import App from '../../../app';

class SCR0302Controller {
	
	constructor ($scope, $state, $uibModalInstance, $timeout, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		this.initWindow(640, 420);
		this.initText();
		
		this.$timeout(() => {
			this.initPermGridOption();
			this.getPermList();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = this.data.text;
	}
	
	initPermGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return dataRow + 1;
        		}
    		}, 
    		 {fieldName: "permId"}, {fieldName: "permNm"}, {fieldName: "permTypeCd"}, {fieldName: "permDesc"}, 
    		 {fieldName: "check", dataType: 'boolean'}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "permId", fieldName: "permId", header : { text: this.text.permId }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "permNm", fieldName: "permNm", header : { text: this.text.permNm }, width: 100, styles: { textAlignment: 'center' } }
		]);
		
		this.gridView.onItemChecked = (grid, itemIndex, checked) => {
			grid.setValue(itemIndex, 5, checked);
		};
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getPermList() {
		const roleId = this.data.roleId;
		
		this.httpService.get(`/roles/${roleId}/permpopups`).then(data => {
			data.map((v) => {
				v.check = false;
			});
			
			this.dataProvider.setRows(data);
		});
	}
	
	closeModal(isOk){
		if(isOk){
			this.$uibModalInstance.close(this.dataProvider.getJsonRows());
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
}

module(App.name).controller('SCR0302Controller', SCR0302Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR0302/SCR0302.controller.js